(function(app) {
    'use strict';

    /**
     * Variable Product Integration Component
     * Handles variation changes for WooCommerce variable products
     * Updates canvas images and layer data when variations are selected
     */
    app.VariableProduct = {
        priority: 85, // Initialize after canvas but before other components

        init() {
            this.setupVariationHandlers();
        },

        setupVariationHandlers() {
            // Listen for WooCommerce variation events
            const variationForm = document.querySelector('.variations_form');
            if (!variationForm) {
                console.log('No variation form found - not a variable product');
                return; // Not a variable product
            }
            
            console.log('Setting up variation handlers for variable product');

            // Handle variation selection change
            variationForm.addEventListener('found_variation', (event) => {
                console.log('WooCommerce found_variation event triggered');
                this.handleVariationChange(event.detail.variation);
            });

            // Handle variation reset
            variationForm.addEventListener('reset_data', () => {
                console.log('WooCommerce reset_data event triggered');
                this.handleVariationReset();
            });

            // Also listen for direct variation changes (backup)
            const variationSelects = variationForm.querySelectorAll('select[name^="attribute_"]');
            console.log('Found', variationSelects.length, 'variation selects');
            variationSelects.forEach(select => {
                select.addEventListener('change', () => {
                    console.log('Variation select changed:', select.name, '=', select.value);
                    // Small delay to let WooCommerce process the change first
                    setTimeout(() => this.checkForVariationUpdate(), 100);
                });
            });
        },

        handleVariationChange(variation) {
            console.log('Variation changed:', variation);
            
            if (!variation) return;

            // Update product image if variation has one
            if (variation.image && variation.image.url) {
                this.updateCanvasBaseImage(variation.image.url);
                this.updateLayersData(variation);
            }

            // Update product ID for price calculations
            if (variation.variation_id) {
                app.Store.setState('productId', variation.variation_id);
                app.Store.setState('variationId', variation.variation_id);
            }

            // Update base price
            if (variation.display_price) {
                app.Store.setState('basePrice', parseFloat(variation.display_price));
            }

            // Trigger canvas redraw
            if (app.CanvasRenderer && app.CanvasRenderer.isReady() && builderType != 'none') {
                app.CanvasRenderer.draw();
            }

            // Trigger price recalculation
            if (app.DataManager) {
                app.DataManager.triggerPriceUpdate();
            }
        },

        handleVariationReset() {
            console.log('Variation reset');
            
            // Reset to main product data
            app.Store.setState('productId', window.productId);
            app.Store.setState('variationId', null);
            
            // Reset to original base image and layers
            const originalLayers = window.layersData || [];
            if (originalLayers.length > 0) {
                const baseLayer = originalLayers.find(layer => layer.id === 'base');
                if (baseLayer && baseLayer.url) {
                    this.updateCanvasBaseImage(baseLayer.url);
                }
            }

            // Trigger canvas redraw
            if (app.CanvasRenderer && app.CanvasRenderer.isReady()) {
                app.CanvasRenderer.draw();
            }

            // Trigger price recalculation
            if (app.DataManager) {
                app.DataManager.triggerPriceUpdate();
            }
        },

        updateCanvasBaseImage(imageUrl) {
            // Update the layers data with new base image
            const currentLayers = app.Store.getState('layers') || [];
            const updatedLayers = currentLayers.map(layer => {
                if (layer.id === 'base') {
                    return { ...layer, url: imageUrl };
                }
                return layer;
            });

            // If no base layer exists, create one
            if (!updatedLayers.find(layer => layer.id === 'base')) {
                updatedLayers.unshift({ url: imageUrl, id: 'base' });
            }

            app.Store.setState('layers', updatedLayers);

            // Update window.layersData for compatibility
            window.layersData = updatedLayers;
        },

        updateLayersData(variation) {
            // Handle any variation-specific layer data
            // This can be extended based on specific requirements
            
            // For now, just ensure the base image is updated
            if (variation.image && variation.image.url) {
                const layers = app.Store.getState('layers') || [];
                const hasBaseLayer = layers.some(layer => layer.id === 'base');
                
                if (!hasBaseLayer) {
                    layers.unshift({ url: variation.image.url, id: 'base' });
                    app.Store.setState('layers', layers);
                }
            }
        },

        checkForVariationUpdate() {
            // Check if a valid variation is currently selected
            const variationForm = document.querySelector('.variations_form');
            if (!variationForm) return;

            const selectedVariation = this.getCurrentlySelectedVariation();
            console.log('looking for variation:');
            console.log(selectedVariation);
            if (selectedVariation) {
                console.log('found the variation!');
                this.handleVariationChange(selectedVariation);
            }
        },

        getCurrentlySelectedVariation() {
            // Get currently selected variation from WooCommerce data
            const variationForm = document.querySelector('.variations_form');
            if (!variationForm) return null;

            const formData = new FormData(variationForm);
            const attributes = {};
            
            // Collect selected attributes
            for (const [key, value] of formData.entries()) {
                if (key.startsWith('attribute_') && value) {
                    attributes[key] = value;
                }
            }

            // Find matching variation (this is a simplified approach)
            // In a real implementation, you might want to use WooCommerce's variation finder
            const variationsData = window.wc_variation_data || {};
            if (variationsData.available_variations) {
                return variationsData.available_variations.find(variation => {
                    return Object.keys(attributes).every(attr => 
                        !variation.attributes[attr] || variation.attributes[attr] === attributes[attr]
                    );
                });
            }

            return null;
        }
    };

})(window.app = window.app || {}); 